import ReactApexChart from 'react-apexcharts'
import { Card, CardBody, Col } from 'reactstrap'
import { OrdersStatus } from '../../../../utils/Constant'
import { orderStatusChart } from '../../../../Data/Widgets/WidgetsChartData'
import CardHeaderCommon from '../../../../CommonElements/CommonCardHeader/CardHeaderCommon'

const OrderStatusWidgets = () => {
  return (
    <Col xl="7" lg="12" className="box-col-6">
      <Card>
        <CardHeaderCommon title={OrdersStatus} />
        <CardBody>
          <div className="chart-container">
            <ReactApexChart options={orderStatusChart} series={orderStatusChart.series} type="line" height={350}/>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default OrderStatusWidgets